import { useState } from "react";
import { toast } from "react-toastify";
import { POST_Remove_arquivo } from "../../../../../../../service/api";

export function useRemocaoDocumento({ numeroSolicitacao, setObjDocs, fetchData, fetchListDocumento }) {
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [modalConfirmarAberto, setModalConfirmarAberto] = useState(false);
  const [arquivoEmRemocao, setArquivoEmRemocao] = useState(null);
  const [confirmandoRemocao, setConfirmandoRemocao] = useState(false);

  const abrirConfirmacao = (caminhoArquivo) => {
    setArquivoSelecionado(caminhoArquivo);
    setModalConfirmarAberto(true);
  };

  const fecharConfirmacao = () => setModalConfirmarAberto(false);

  const removerDocumento = async (caminhoArquivo) => {
    setArquivoEmRemocao(caminhoArquivo);
    try {
      await POST_Remove_arquivo("/ordem-servico/documento/remover", {
        id: numeroSolicitacao,
        files: [caminhoArquivo],
      });
      await fetchData();
      await fetchListDocumento();
    } catch (error) {
      toast.error(`Erro: ${error.message}`);
    } finally {
      setArquivoEmRemocao(null);
    }
  };

  const confirmarRemocao = async () => {
    if (!arquivoSelecionado) return;
    setConfirmandoRemocao(true);
    try {
      await removerDocumento(arquivoSelecionado);
      setObjDocs((prevDocs) => prevDocs.filter((arquivo) => arquivo !== arquivoSelecionado));
      setModalConfirmarAberto(false);
    } finally {
      setConfirmandoRemocao(false);
    }
  };

  return {
    arquivoEmRemocao,
    modalConfirmarAberto,
    confirmandoRemocao,
    abrirConfirmacao,
    fecharConfirmacao,
    confirmarRemocao,
  };
}
